export default __webpack_public_path__ + "static/media/PartsImportSample.af97d143.xlsx";